<template lang="pug">
  .modal(v-if="value", :id="id", :class="('modal-' + type) + (value ? ' ___in' : '')", )
    .modal-dialog(ref="modal", :class="{'modal-lg': size === 'large', 'modal-xlg': size === 'xlarge'}")
      .modal-content(data-testid="-content")
        .modal-header
          slot(name="header", :close="close")
            button.close(v-if="showClose" type="button", @click="close" data-testid="-btn-header-close"): span &times;
            h4.modal-title: slot(name="title", :close="close")
        .modal-body(:style="height ? 'max-height: ' + height + 'px;' : ''")
          slot(:close="close")
        .modal-footer
          slot(name="footer", :close="close")
            button.btn.btn-default(type="button", @click="close" data-testid="-btn-close") 閉じる
</template>

<script>
import 'jquery-ui/ui/widgets/draggable'
import 'jquery-ui/themes/base/draggable.css'

export default {
  name: 'AppModal',
  props: {
    type: {type: String, required: false, default: 'default'},
    size: {type: String, required: false, default: '', validate (value) { this.isIncludes(['xlarge', 'large', ''], value) }},
    height: {type: Number, required: false, default: null},
    value: {type: Boolean, required: false, default: false}, // 開閉状態
    showClose: {type: Boolean, required: false, default: true} // [×]ボタン表示フラグ
  },
  data: function () {
    return {
      $rootEl: null,
      id: ''
    }
  },
  watch: {
    value: function (newValue, oldValue) {
      // open時の設定
      if (newValue && !oldValue) {
        this._onModalOpen(false)
      }
      // close時の設定
      else if (!newValue && oldValue) {
        this._onModalClose(false)
      }
    }
  },
  mounted: function () {
    // open時の設定
    if (this.value) {
      // 諸事情でmodalにv-if="isOpen"をつけていると、watchではなくこちらを通る
      this._onModalOpen(true)
    }
  },
  beforeDestroy: function () {
    // close時の設定
    // 諸事情でmodalにv-if="isOpen"をつけていると、watchではなくこちらを通る
    this._onModalClose(true)
  },
  methods: {
    close: function () {
      // 開閉状態をfalseにする
      this.$emit('input', false)
    },
    setPosition: function (modalCount) {
      this.id = 'app-modal-' + modalCount
      // モーダルが表示されるのを待つ
      const vm = this
      this.$nextTick(function () {
        $(vm.$refs.modal).draggable({
          handle: '.modal-header',
          containment: 'parent'
        })
      })
    },
    /**
     * モーダルが開いているときは、後ろの画面の操作をロックする
     */
    _lockBackgroundHandler: function (e) {
      // F5はモーダル以外にフォーカスが当たっていても受け入れる
      if (e.keyCode === 116) {
        return
      }
      // 操作した場所が一番上のモーダル以外 かつ datePicker以外である場合、無視する
      const modalCount = this.rootEl().getElementsByClassName('modal').length
      const $lastModal = document.getElementById('app-modal-' + modalCount)
      if (!$lastModal) {
        return
      }
      if (!$lastModal.contains(e.target) && !e.target.className.includes('ui-datepicker-')) {
        e.preventDefault()
        e.stopPropagation()
        return false
      }
    },
    _lockBackground: function () {
      // 二重イベントにならないように、一旦解除
      this._unlockBackground()
      $(document).on(
        'mousedown.modal mouseup.modal keydown.modal keyup.modal',
        'a, input, button, select, textarea',
        this._lockBackgroundHandler
      )
    },
    _unlockBackground: function () {
      $(document).off(
        'mousedown.modal mouseup.modal keydown.modal keyup.modal',
        'a, input, button, select, textarea'
      )
    },
    /**
     * @param mounted mountedから呼ばれた場合、自分がlengthに入る
     *                watchから呼ばれた場合、自分がlengthに入らない
     */
    _onModalOpen: function (mounted) {
      const modalCount = (mounted ? 0 : 1) + this.rootEl().getElementsByClassName('modal').length
      this.setPosition(modalCount)
      // 最初の立ち上げのときのみイベント設定
      if (modalCount === 1) {
        this.disableScroll()
        this._lockBackground()
      }
    },
    /**
     * @param destroyed beforeDestroyから呼ばれた場合、自分がlengthに入らない
     *                  watchから呼ばれた場合、自分がlengthに入る
     */
    _onModalClose: function (destroyed) {
      const modalCount = (destroyed ? 0 : -1) + this.rootEl().getElementsByClassName('modal').length
      // 他に開いているmodalがなければイベント解除
      if (modalCount === 0) {
        this.enableScroll()
        this._unlockBackground()
      }
    },
    rootEl: function () {
      if (!this.$rootEl) {
        this.$rootEl = this.$root.$el
      }
      return this.$rootEl
    }
  }
}
</script>

<style scoped>
.modal {
  display: block;
  overflow: auto; /* 小さい画面でスクロールを出すようにする */
}
/* dragライブラリの装飾を消す */
.vdr.active:before {
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/templates/AppModal.vue